<div class="cv-shell">
  <div class="cv-side">
    <div class="cv-side-badge">
      <app-admin-v2-icon name="shield" [size]="22"></app-admin-v2-icon>
    </div>
    <div class="cv-side-copy">
      <div class="cv-side-title">Secure card verification</div>
      <div class="cv-side-desc">A one-time password sent to your registered mobile confirms it's you before the card number and CVV are shown.</div>
    </div>
  </div>

  <div class="cv-panel">
    <div class="cv-mobile-header">
      <span class="cv-mobile-header-icon">
        <app-admin-v2-icon name="shield" [size]="16"></app-admin-v2-icon>
      </span>
      <span class="cv-mobile-header-title">Secure card verification</span>
    </div>

    <div class="cv-content" [class.cv-content--top]="phase === 'card'">
      <div class="cv-inner">

        @if (phase === 'loading') {
          <div class="cv-skeleton">
            <div class="cv-skel cv-skel-card"></div>
            <div class="cv-skel cv-skel-line" style="width: 40%"></div>
            <div class="cv-skel cv-skel-line" style="width: 55%; height: 28px"></div>
            <div class="cv-skel-caption">Sending verification code…</div>
          </div>
        }

        @if (phase === 'error') {
          <div class="cv-error">
            <div class="cv-error-icon">
              <app-admin-v2-icon name="alert" [size]="24"></app-admin-v2-icon>
            </div>
            <div class="cv-error-title">Something went wrong</div>
            <div class="cv-error-desc">{{ errorMessage }}</div>
            <button type="button" class="cv-retry-btn" (click)="retry()">Try again</button>
          </div>
        }

        @if (phase === 'otp') {
          <div class="cv-otp-head">
            <div class="cv-otp-icon">
              <app-admin-v2-icon name="shield" [size]="24"></app-admin-v2-icon>
            </div>
            <div class="cv-otp-title">Verify to view card</div>
            <div class="cv-otp-sub">Enter the 6-digit code to view secure card details.</div>
            <div class="cv-otp-pill">
              <app-admin-v2-icon name="message" [size]="15"></app-admin-v2-icon>
              <span>Code sent to <strong>{{ maskedContact }}</strong></span>
            </div>
          </div>

          <div class="cv-otp-cells" [class.shake]="otpShake" [class.err]="!!otpError" (paste)="onOtpPaste($event)">
            @for (value of otpValues; track $index) {
              <input
                #otpCell
                type="text"
                inputmode="numeric"
                maxlength="1"
                autocomplete="one-time-code"
                [value]="value"
                [disabled]="otpSubmitting"
                (input)="onOtpDigit($index, $any($event.target).value)"
                (keydown)="onOtpKeydown($index, $event)"
                [attr.aria-label]="'Digit ' + ($index + 1)"
              />
            }
          </div>

          @if (otpError) {
            <div class="cv-otp-error">{{ otpError }}</div>
          }

          <button type="button" class="cv-verify-btn" [disabled]="verifyDisabled" (click)="verifyOtp()">
            @if (otpSubmitting) {
              <span class="cv-spin"></span>
            }
            Verify &amp; continue
          </button>

          <div class="cv-resend">
            @if (resendSeconds > 0) {
              <span class="cv-resend-wait">Resend OTP in 0:{{ resendSeconds < 10 ? '0' + resendSeconds : resendSeconds }}</span>
            } @else {
              <a href="javascript:void(0)" class="cv-resend-link" (click)="resendOtp()">{{ otpSending ? 'Sending…' : 'Resend OTP' }}</a>
            }
          </div>
        }

        @if (phase === 'card' && revealedCard) {
          <div class="cv-card">
            <div class="cv-card-glow"></div>

            <div class="cv-card-top">
              <span class="cv-chip"><span></span><span></span></span>
              <span class="cv-contactless">
                <app-admin-v2-icon name="wifi" [size]="20"></app-admin-v2-icon>
              </span>
              <img src="assets/svg/card-holder/logo-enkash-card-white.svg" alt="EnKash" class="cv-card-logo" />
            </div>

            <div class="cv-card-number">{{ displayNumber }}</div>

            <div class="cv-card-bottom">
              <div class="cv-card-field cv-card-field--holder">
                <span class="cv-card-label">Card holder</span>
                <span class="cv-card-value">{{ displayHolderName }}</span>
              </div>
              <div class="cv-card-field">
                <span class="cv-card-label">Valid thru</span>
                <span class="cv-card-value mono">{{ displayExpiry }}</span>
              </div>
              <div class="cv-card-field">
                <span class="cv-card-label">CVV</span>
                <span class="cv-card-value mono">{{ displayCvv }}</span>
              </div>
            </div>
          </div>

          @if (!revealField) {
            <button type="button" class="cv-cta-btn" (click)="viewDetailsAgain()">
              <app-admin-v2-icon name="eye" [size]="16"></app-admin-v2-icon>
              View card details
            </button>
          } @else {
            <div class="cv-seg-row">
              <div class="cv-seg">
                <button type="button" class="cv-seg-btn" [class.on]="revealField === 'number'" (click)="showField('number')">Card number</button>
                <button type="button" class="cv-seg-btn" [class.on]="revealField === 'cvv'" (click)="showField('cvv')">CVV</button>
              </div>
              <div class="cv-seg-right">
                <span class="cv-reveal-timer">{{ revealTimeLabel }}</span>
                <button type="button" class="cv-hide-btn" (click)="hideNow()">Hide</button>
              </div>
            </div>
            <div class="cv-seg-note">For your security, only one detail is shown at a time.</div>
          }

          <div class="cv-balance-row">
            <div class="cv-balance-label">Available balance</div>
            <div class="cv-balance-value">
              <span>{{ formattedBalanceWhole }}</span><span class="cv-balance-decimal">{{ formattedBalanceDecimal }}</span>
            </div>
          </div>
        }

      </div>
    </div>

    <div class="cv-footer">
      <img src="assets/svg/powered-by-enkash.png" alt="Powered by EnKash" class="cv-footer-logo" />
    </div>
  </div>
</div>
